import CEEA_43N_N from './43N_N'
import CEEA_42N_Q from './42N_Q'
import CEEA_38N_R from './38N_R'
import CEEA_38N_R_RHD from './38N_R_RHD'
import CEEA_43N_R_RHD from './43N_R_RHD'
import M2_H from './M2_H'
import M2_G from './M2_G'
import M2_K from './M2_K'
import OVERHEAD_35M_001 from './OVERHEAD_35M_001'
import CHECPLUS_42N_Q_734_025 from './42N_Q_734_025'
import OVERHEAD_35M_002 from './OVERHEAD_35M_002'
import OVERHEAD_35M_003 from './OVERHEAD_35M_003'
import OVERHEAD_35M_004 from './OVERHEAD_35M_004'
import OVERHEAD_35M_005 from './OVERHEAD_35M_005'
import OVERHEAD_35M_006 from './OVERHEAD_35M_006'
import OVERHEAD_35M_007 from './OVERHEAD_35M_007'
import OVERHEAD_35M_008 from './OVERHEAD_35M_008'
import OVERHEAD_35M_009 from './OVERHEAD_35M_009'
import SLLG_43N from './SLLG_43N'
import SLSM_43N from './SLSM_43N'
import OVERHEAD_4E1_998_DAY from './OVERHEAD_4E1_998_DAY'
import OVERHEAD_4E1_998_EXTENDED from './OVERHEAD_4E1_998_EXTENDED'
import OVERHEAD_4E1_001_DAY from './OVERHEAD_4E1_001_DAY'
import OVERHEAD_4E1_001_EXTENDED from './OVERHEAD_4E1_001_EXTENDED'
import OVERHEAD_4E1_002_DAY from './OVERHEAD_4E1_002_DAY'
import OVERHEAD_4E1_002_EXTENDED from './OVERHEAD_4E1_002_EXTENDED'
import OVERHEAD_4E1_003_DAY from './OVERHEAD_4E1_003_DAY'
import OVERHEAD_4E1_003_EXTENDED from './OVERHEAD_4E1_003_EXTENDED'
import OVERHEAD_4E1_004_DAY from './OVERHEAD_4E1_004_DAY'
import OVERHEAD_4E1_005_DAY from './OVERHEAD_4E1_005_DAY'
import OVERHEAD_4E1_006_DAY from './OVERHEAD_4E1_006_DAY'
import OVERHEAD_4E1_006_EXTENDED from './OVERHEAD_4E1_006_EXTENDED'
import OVERHEAD_4E1_007_DAY from './OVERHEAD_4E1_007_DAY'
import OVERHEAD_4E1_007_EXTENDED from './OVERHEAD_4E1_007_EXTENDED'
import OVERHEAD_4E1_008_DAY from './OVERHEAD_4E1_008_DAY'
import OVERHEAD_4E1_008_EXTENDED from './OVERHEAD_4E1_008_EXTENDED'
import OVERHEAD_4E1_009_DAY from './OVERHEAD_4E1_009_DAY'
import OVERHEAD_4E1_010_DAY from './OVERHEAD_4E1_010_DAY'
import OVERHEAD_4E1_010_EXTENDED from './OVERHEAD_4E1_010_EXTENDED'
import OVERHEAD_4E1_011_DAY from './OVERHEAD_4E1_011_DAY'
import OVERHEAD_4E1_012_DAY from './OVERHEAD_4E1_012_DAY'
import OVERHEAD_4E1_014_DAY from './OVERHEAD_4E1_014_DAY'
import OVERHEAD_4E1_015_DAY from './OVERHEAD_4E1_015_DAY'
import OVERHEAD_4E1_016_EXTENDED from './OVERHEAD_4E1_016_EXTENDED'
import OVERHEAD_4E1_017_DAY from './OVERHEAD_4E1_017_DAY'
import OVERHEAD_4E1_018_EXTENDED from './OVERHEAD_4E1_018_EXTENDED'
import OVERHEAD_4E1_018_DAY from './OVERHEAD_4E1_018_DAY'
import CEEA_42N_Q_BUS from './42N_Q_001_310'
import CEEA_42N_Q_RV from './42N_Q_001_343'
import CEEA_42N_Q_BUS_CHECP from './42N_Q_CHECP'
import CEEA_42N_Q_BUS_CHECP_SCHOOL from './42N_Q_CHECP_BUS'

import { DASH_CODE_SEPARATOR } from './dashConstants'
import OVERHEAD_4E1_014_EXTENDED from './OVERHEAD_4E1_014_EXTENDED'

const definitions = {
  Q: CEEA_42N_Q,
  N: CEEA_43N_N,
  R: CEEA_38N_R,
  G: M2_G,
  K: M2_K,
  H: M2_H,
  [`003-002${DASH_CODE_SEPARATOR}43N`]: CEEA_43N_R_RHD,
  [`003-002${DASH_CODE_SEPARATOR}38N`]: CEEA_38N_R_RHD,
  '35M-001': OVERHEAD_35M_001,
  '35M-002': OVERHEAD_35M_002,
  '35M-003': OVERHEAD_35M_003,
  '35M-004': OVERHEAD_35M_004,
  '35M-005': OVERHEAD_35M_005,
  '35M-006': OVERHEAD_35M_006,
  '35M-007': OVERHEAD_35M_007,
  '35M-008': OVERHEAD_35M_008,
  '35M-009': OVERHEAD_35M_009,
  '682-090': SLLG_43N,
  '682-091': SLLG_43N,
  '682-092': SLLG_43N,
  '682-088': SLSM_43N,
  '682-093': SLSM_43N,
  '682-094': SLSM_43N,
  '4E1-998_DAY': OVERHEAD_4E1_998_DAY,
  '4E1-998_EXTENDED': OVERHEAD_4E1_998_EXTENDED,
  '4E1-001_DAY': OVERHEAD_4E1_001_DAY,
  '4E1-001_EXTENDED': OVERHEAD_4E1_001_EXTENDED,
  '4E1-002_DAY': OVERHEAD_4E1_002_DAY,
  '4E1-002_EXTENDED': OVERHEAD_4E1_002_EXTENDED,
  '4E1-003_DAY': OVERHEAD_4E1_003_DAY,
  '4E1-003_EXTENDED': OVERHEAD_4E1_003_EXTENDED,
  '4E1-004_DAY': OVERHEAD_4E1_004_DAY,
  '4E1-005_DAY': OVERHEAD_4E1_005_DAY,
  '4E1-006_DAY': OVERHEAD_4E1_006_DAY,
  '4E1-006_EXTENDED': OVERHEAD_4E1_006_EXTENDED,
  '4E1-007_DAY': OVERHEAD_4E1_007_DAY,
  '4E1-007_EXTENDED': OVERHEAD_4E1_007_EXTENDED,
  '4E1-008_DAY': OVERHEAD_4E1_008_DAY,
  '4E1-008_EXTENDED': OVERHEAD_4E1_008_EXTENDED,
  '4E1-009_DAY': OVERHEAD_4E1_009_DAY,
  '4E1-010_DAY': OVERHEAD_4E1_010_DAY,
  '4E1-010_EXTENDED': OVERHEAD_4E1_010_EXTENDED,
  '4E1-011_DAY': OVERHEAD_4E1_011_DAY,
  '4E1-012_DAY': OVERHEAD_4E1_012_DAY,
  '4E1-014_DAY': OVERHEAD_4E1_014_DAY,
  '4E1-015_DAY': OVERHEAD_4E1_015_DAY,
  '4E1-016_EXTENDED': OVERHEAD_4E1_016_EXTENDED,
  '4E1-014_EXTENDED': OVERHEAD_4E1_014_EXTENDED,
  '4E1-017_DAY': OVERHEAD_4E1_017_DAY,
  '4E1-018_DAY': OVERHEAD_4E1_018_DAY,
  '4E1-018_EXTENDED': OVERHEAD_4E1_018_EXTENDED,
  '001-310_42N_BUS': CEEA_42N_Q_BUS,
  '001-343_42N_RV': CEEA_42N_Q_RV,
  CHECP_42N_BUS: CEEA_42N_Q_BUS_CHECP,
  CHECP_42N_BUS_SCHOOL: CEEA_42N_Q_BUS_CHECP_SCHOOL,
  CHECPLUS_42N_Q_734_025,
}

export default definitions
